export const baseURL = "https://live.popsicle.ly/api";
// export const baseURL = "http://testing.popsicle.ly/api";
// export const baseURL = "http://localhost:4000/";
